module.exports = __webpack_public_path__ + "img/banner.231e0de9.webp";